import React from 'react';
import { subscribe } from 'reffects-store';
import { KEYWORDS_IN_AD_CONTENT_CRITERION } from 'components/UnifiedCampaignForm/constants';
import SegmentationCriterionWrapper from './SegmentationCriterionWrapper';
import { segmentationCriterionSelector } from '../selectors';
import {
    onRemoveCriterion,
    onChangeCriterionValue,
    onChangeCriterionOperation,
} from './eventDispatchers';
import CriteriaText from './CriteriaInputs/CriteriaText';

function KeywordsInAdContentCriterion({
    visible,
    operation,
    field,
    value,
    label,
    onRemove,
    onChangeOperation,
    onChangeValue,
}) {
    return (
        <SegmentationCriterionWrapper
            visible={visible}
            label={label}
            field={field}
            value={value}
            onRemove={onRemove}
        >
            <CriteriaText
                operation={operation}
                field={field}
                value={value}
                onChangeCriteriaOperation={onChangeOperation}
                onChangeCriteriaValue={onChangeValue}
            />
        </SegmentationCriterionWrapper>
    );
}

export default subscribe(
    KeywordsInAdContentCriterion,
    function mapStateToProps(state) {
        const segmentationCriterion = segmentationCriterionSelector(
            KEYWORDS_IN_AD_CONTENT_CRITERION
        )(state);

        return { ...segmentationCriterion };
    },
    {
        onRemove: onRemoveCriterion,
        onChangeOperation: onChangeCriterionOperation,
        onChangeValue: onChangeCriterionValue,
    }
);
